import { gql } from "@apollo/client"

const GET_STAFF_SCHEDULE_PDF_DOWNLOAD_LINK = gql`
  query staffSchedulePDFDownload($input: StaffSchedulePDFDownloadInput!) {
    staffSchedulePDFDownload(input: $input) {
      filename
      url
      type
      queued
    }
  }
`

export { GET_STAFF_SCHEDULE_PDF_DOWNLOAD_LINK }